import { render, staticRenderFns } from "./addskipNoviceBoot.vue?vue&type=template&id=66b815c0&"
import script from "./addskipNoviceBoot.vue?vue&type=script&lang=js&"
export * from "./addskipNoviceBoot.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66b815c0')) {
      api.createRecord('66b815c0', component.options)
    } else {
      api.reload('66b815c0', component.options)
    }
    module.hot.accept("./addskipNoviceBoot.vue?vue&type=template&id=66b815c0&", function () {
      api.rerender('66b815c0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gmToolNew/skipNoviceBoot/components/addskipNoviceBoot.vue"
export default component.exports